import React, { useContext } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Container,
  Col,
} from "reactstrap";
import CustomInput from "components/common/AuthInput";
import { useFormik } from "formik";
import { ErrorToaster } from "components/common/toast";
import { Link, useNavigate } from "react-router-dom";
import { loginApi } from "network/user";
import InputPassword from "components/common/input-password";
import PATHS from "constant/paths";
import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import handleError from "utils/handleError";
import { UserContextProvider } from "context/UserContext";
import { LoginSchema } from "components/schema/LoginSchema";

const Login = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const { fetchUser, fetchSection } = useContext(UserContextProvider);

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    enableReinitialize: true,
    validationSchema: LoginSchema,

    onSubmit: async (values) => {
      try {
        const response = await loginApi(values);
        if (response.success) {
          localStorage.setItem("token", response?.data?.access_token);
          fetchUser();
          fetchSection();
          navigate("/dashboard");
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
      }
    },
  });
  return (
    <>
      <div className="content">
        <Col className="ml-auto mr-auto" lg="4" md="6">
          <Form className="form" onSubmit={handleSubmit}>
            <Card className="card-login card-white">
              <CardHeader>
                <img className="risto-login-logo" alt="Risto Platform" src={require("assets/img/risto-platform-logo-gold.png")} />
                <CardTitle tag="h6">{t("login.title")}</CardTitle>
              </CardHeader>
              <CardBody>
                <CustomInput
                  icon={<i className="tim-icons icon-email-85" />}
                  name="email"
                  placeholder={t("login.email")}
                  type="email"
                  errors={errors}
                  touched={touched}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values}
                />
                <InputPassword
                  icon={<i className="tim-icons icon-lock-circle" />}
                  name="password"
                  placeholder={t("login.password")}
                  type="password"
                  errors={errors}
                  touched={touched}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values}
                />
              </CardBody>
              <CardFooter>
                <BtnCustom
                  block
                  isLoading={isSubmitting}
                  color="primary"
                  size="lg"
                  type="submit"
                  submittingText={t("login.loggingIn")}
                >
                  {t("login.submit")}
                </BtnCustom>
                <div className="pull-left">
                  <h6>
                    <Link className="link footer-link" to={PATHS.REGISTER}>
                      {t("login.createAccount")}
                    </Link>
                  </h6>
                </div>
                <div className="pull-right">
                  <h6>
                    <Link
                      className="link footer-link"
                      to={PATHS.FORGOT_PASSWORD}
                    >
                      {t("login.forgotPassword")}
                    </Link>
                  </h6>
                </div>
              </CardFooter>
            </Card>
          </Form>
        </Col>
      </div>
    </>
  );
};

export default Login;
